var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconNoticeBoard32Filled = function SvgIconNoticeBoard32Filled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.053 9.086h1.127V6.82H4.82v2.266h1.127v10.8c0 1.066.867 1.934 1.933 1.934h3.746l-2.672 3.002 1.494 1.33 3.856-4.332h3.393l3.857 4.331 1.494-1.33-2.673-3.001h3.745a1.936 1.936 0 0 0 1.933-1.934v-10.8ZM10.301 13.44h11.4v-2H10.3v2Zm0 3.894H16v-2h-5.7v2Z",
    fill: "current"
  })));
};
export default SvgIconNoticeBoard32Filled;